import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../LanguageContext';
import { Facebook, Instagram, Linkedin } from 'lucide-react';

const Footer = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  return (
    <footer className="bg-black border-t border-gold/20 py-12">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div>
            <h4 className="text-white font-semibold mb-4">{t('footer.services')}</h4>
            <ul className="space-y-2">
              <li><a href="/airport-transfer-brussels" className="text-gray-400 hover:text-gold transition-colors">Transfert Aéroport</a></li>
              <li><a href="/private-chauffeur-brussels" className="text-gray-400 hover:text-gold transition-colors">Chauffeur Privé</a></li>
              <li><a href="/taxi-bruxelles" className="text-gray-400 hover:text-gold transition-colors">Taxi Bruxelles</a></li>
              <li><a href="/loyalty" className="text-gray-400 hover:text-gold transition-colors">Programme Fidélité</a></li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-white font-semibold mb-4">{t('footer.company')}</h4>
            <ul className="space-y-2">
              <li><a href="/#about" className="text-gray-400 hover:text-gold transition-colors">{t('footer.about')}</a></li>
              <li><a href="/#fleet" className="text-gray-400 hover:text-gold transition-colors">{t('footer.fleet')}</a></li>
              <li><a href="/privacy-policy" className="text-gray-400 hover:text-gold transition-colors">Politique de Confidentialité</a></li>
              <li><a href="/terms" className="text-gray-400 hover:text-gold transition-colors">Conditions Générales</a></li>
              <li><a href="/loyalty" className="text-gray-400 hover:text-gold transition-colors">Programme Fidélité</a></li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-white font-semibold mb-4">{t('footer.contact')}</h4>
            <ul className="space-y-2 text-gray-400">
              <li>Email: contact@luxurytransferservices.be</li>
              <li>Tel: +32 2 315 02 54</li>
              <li>{t('footer.available247')}</li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gold/20 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            {/* Social Media */}
            <div className="flex items-center gap-4">
              <span className="text-gray-400 text-sm">Suivez-nous :</span>
              <a
                href="https://www.facebook.com/LuxuryTransferService/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-gold transition-colors p-2 hover:bg-gold/10 rounded-full"
                aria-label="Facebook"
              >
                <Facebook className="h-5 w-5" />
              </a>
              <a
                href="https://www.instagram.com/luxurytransferservice"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-gold transition-colors p-2 hover:bg-gold/10 rounded-full"
                aria-label="Instagram"
              >
                <Instagram className="h-5 w-5" />
              </a>
              <a
                href="https://www.linkedin.com/company/luxury-transfer-service"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-gold transition-colors p-2 hover:bg-gold/10 rounded-full"
                aria-label="LinkedIn"
              >
                <Linkedin className="h-5 w-5" />
              </a>
            </div>
            
            {/* Links */}
            <div className="flex flex-wrap justify-center gap-4 text-sm text-gray-400">
              <button onClick={() => navigate('/privacy-policy')} className="hover:text-gold transition-colors">
                Politique de Confidentialité
              </button>
              <span>•</span>
              <button onClick={() => navigate('/terms')} className="hover:text-gold transition-colors">
                Conditions Générales
              </button>
              <span>•</span>
              <button onClick={() => navigate('/loyalty')} className="hover:text-gold transition-colors">
                Programme Fidélité
              </button>
            </div>
            <p className="text-center text-gray-400 text-sm">{t('footer.copyright')}</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;